import { Mastertrust, Pesb, StratX, Swastika, UtradePro } from "../../src/_vendors";
import { HelpInfoInterface } from "./app.interface";

export let Instrument;
(function (reverseInst) {
    reverseInst[reverseInst['common_stock'] = 'Equity'] = 'common_stock';
    reverseInst[reverseInst['future'] = 'Future'] = 'future';
    reverseInst[reverseInst['option'] = 'Option'] = 'option';
    reverseInst[reverseInst['index'] = 'Index'] = 'index';
})(Instrument || (Instrument = {}));

export let chartInstrument;
(function (reverseInst) {
    reverseInst[reverseInst['C'] = 'Equity'] = 'common_stock';
    reverseInst[reverseInst['future'] = 'Future'] = 'future';
    reverseInst[reverseInst['option'] = 'Option'] = 'option';
    reverseInst[reverseInst['index'] = 'Index'] = 'index';
})(chartInstrument || (chartInstrument = {}));


export enum MarketKeywords {
    BSECM = 'BSECM',
    BSEFO = 'BSEFO',
    NSECM = 'NSECM',
    NSEFO = 'NSEFO',
    ESMNSE = 'ESMNSE',
    ESM = 'ESMNSE',
    NSECDS = 'NSECDS',
    BSECDS = 'BSECDS',
    MSECM = 'MSECM',
    MSECD = 'MSECD',
    MSEFO = 'MSEFO',
    PLUS = 'PLUS',
    MCX = 'MCX',
    NCDEX = 'NCDEX',
    ESM_SHORT = 'ESM'
}

export enum SortingTypes {
    None = 0,
    Ascending = 1,
    Descending = 2,
}

export enum TRADING_TABS {
    OVERVIEW = 0,
    CHARTS = 1,
    OPTION_CHAIN = 2,
    BOOKS = 3
}

export enum WidgetViewMode {
    DEFAULT = 'default',
    FULLSCREEN = 'fullscreen',
    MINIMISED = 'minimised',
    MAXIMISED = 'maximised'
}

export enum SpotDerivativeMap {
    NSECM = 'NSEFO',
    BSECM = 'BSEFO',
    MSECM = 'MSECM',
    ESMNSE = 'ESMNSE'
}

export enum CustomDateTimeFormat {
    standard_date_time = 'dd MMMM y hh:mm:ss',
    standard_date_24_hr_time = 'dd MMMM y HH:mm:ss',
    mediumTimePadded = 'hh:mm:ss a',
    reversed_date_time = 'y-M-dd HH:mm:ss',
    date_only = 'MM/dd/yy',
    time_only = 'HH:mm:ss',
    time_only_short = 'h:mm a',
    ipo_date_format = 'dd MMM \'\'yy',
    moment_date_format = 'DD-MM-YYYY',
    shortDateMediumTime = 'M/d/yy hh:mm:ss a',
    time_only_short_capitalized = 'h:mm A',
    funds_date_format = 'DD MMM YY',
    books_info_time_format = 'yyyy-MM-dd HH:mm:ss',
    month_year_label = 'MMM YYYY',
    moment_date_short = 'dd-MM-yy'
}

export enum DepthClickType {
    BID_VOL = 'BID_VOL',
    BID_PRICE = 'BID_PRICE',
    ASK_PRICE = 'ASK_PRICE',
    ASK_VOL = 'ASK_VOL'
}

export enum UserTypes {
    client = 'client',
    dealer = 'dealer'
}

export enum Exchange {
    NSE = 'NSE',
    BSE = 'BSE'
}

export enum Series {
    EQ = 'EQ',
    A = 'A'
}


export enum OptionTypeEnum {
    CALL = 'call',
    PUT = 'put'
}


export enum OptionTypeAbbreviatedEnum {
    CALL = 'C',
    PUT = 'P'
}

export enum AccessType {
    web = 2,
    mobile = 3,
}

export enum DeviceTypes {
    chrome = 'Chrome',
    ios = 'ios',
    android = 'android',
}

export const DeviceNameIconMap = {
    'web': { 'name': 'Browser', 'icon': 'browser' },
    'mobile-apple': { 'name': 'Mobile', 'icon': 'apple' },
    'mobile-android': { 'name': 'Mobile', 'icon': 'android' },
};


export const VENDOR_HELP_INFO: { [key: string]: HelpInfoInterface } = {
    [UtradePro.loginSource]: {
        email: 'support@utradealgos.com',
        phone: '18002030404',
        whatsapp: '9599285245'
    },
    [Swastika.loginSource]: {
        email: 'helpdesk@swastika.co.in',
        phone: '080-69049876',
        whatsapp: null
    },
    [Mastertrust.loginSource]: {
        email: 'helpdesk@mastertrust.co.in',
        phone: '+91 120-6223333',
        whatsapp: null
    },
    [StratX.loginSource]: {
        email: 'support@utradealgos.com',
        phone: '18002030404',
        whatsapp: '9599285245'
    },
    [Pesb.loginSource]: {
        email: 'support@utradealgos.com',
        phone: '18002030404',
        whatsapp: '9599285245'
    }
}
export enum PostSILoginRedirect {
    plan = 'plan',
    funds = 'funds',
}

// in the memory of Gaurav Singh (Suggested by him as well)
export enum VerifyDialogCloseReason {
    noAction,
    primaryAction,
    secondaryAction
}